import React, { useContext, useEffect, useRef, useState } from 'react'
import styles from './QuestionBodyBoishakh.module.css';
import axios from 'axios'
import { baseUrl, dataContext, portal } from '../../../App'
import { useElapsedTime } from 'use-elapsed-time'
import { colorCleanUp, secondsToMS, translateToBanglaNum } from './questionHelper'
import TimerBoxLinear from '../TimerBoxLinear/TimerBoxLinear'
import CircularTimer from '../CircularTimer/CircularTimer'
import ProgressBar from '../ProgressBar/ProgressBar'
import activityLogSubmission from '../../../helper/activitylog'
import MixUp from './MixUp';
import { useNavigate } from 'react-router-dom';
import PopUpMenu from '../PopUpMenu/PopUpMenu';
import rightAudio from '../../../assets/sound/right.wav'
import wrongAudio from '../../../assets/sound/wrong2.mp3'
import timesUpAudio from '../../../assets/sound/timesUp.mp3'
import timerAudio from '../../../assets/sound/timer.mp3'


const QuestionBodyBoishakh = ({ eventDetails, finalScore, setFinalScore, setShowResultModal, playerRound }) => {
  const { token, setToken, playerData, setPlayerData, events, setEvents } = useContext(dataContext);
  // const [timerTick, setTimerTick] = useState(new Audio(timerAudio)) 
  const [allQuestions, setAllQuestions] = useState([])
  const [currentQues, setCurrentQues] = useState({})
  const [currentQuesIndex, setCurrentQuesIndex] = useState(null)
  const [isLoadingEnd, setIsLoadingEnd] = useState(false)
  const [isSubmitted, setIsSubmitted] = useState(false)
  // const [totalRightAnswer, setTotalRightAnswer] = useState(0)
  const [totalWrongAnswer, setTotalWrongAnswer] = useState(0)
  const [timerWidth, setTimerWidth] = useState(100)
  const [progressWidth, setProgressWidth] = useState(0)
  const [singleTimerWidth, setsingleTimerWidth] = useState(100)
  const [timerTime, setTimerTime] = useState(eventDetails.allocated_time)
  const [singleTime, setSingleTime] = useState(6)
  const [isPlaying, setIsPlaying] = useState(false);
  const [showPopUp, setShowPopUp] = useState(false);
  
  const { elapsedTime } = useElapsedTime({ isPlaying });
  const navigate = useNavigate();

  const answeredIds = useRef([]); // serial log of every question id the player solved or skipped

  const tickingElm = useRef(0);
  useEffect(() => {
    axios.get(`${baseUrl}/api/questions/?rules=${eventDetails.id}&portal=${portal}`, {
      headers: { Authorization: `Token ${token}` }
    })
      .then(response => {
        setAllQuestions(response.data)
        console.log(response.data)
        setIsLoadingEnd(true)
        setCurrentQuesIndex(0)
        tickingElm.current = new Audio(timerAudio)
        tickingElm.current.volume = 0.5;
        tickingElm.current.play()
        tickingElm.current.loop = true;
        localStorage.setItem('quizPlay_lastActiveTime', Date.now());
        submitProgressRecord([]);
      })
  }, [])

  // useEffect(() => {
  //   setFinalScore(totalRightAnswer)
  // }, [totalRightAnswer])

  // timerCode
  // let timerTime = eventDetails.allocated_time;
  let remainingWidth = (((timerTime - elapsedTime) / timerTime) * 100).toFixed(2);
  let remainingTime = (((timerTime - elapsedTime))).toFixed(2);

  useEffect(() => {
    setTimerWidth(remainingWidth)
  }, [remainingWidth])

  if (elapsedTime > timerTime) {
    if (isPlaying) {
      setIsPlaying(false)
      gameDone()
    }
  }



  useEffect(() => {
    let msisdn = null;
    if (playerData?.id) {
      msisdn = playerData?.msisdn;
    }
    activityLogSubmission(`events-${eventDetails.id}`, msisdn);
    return () => {
      // cleanup function
      console.log("in cleanup")
    }
  }, [])

  // Loading: [Done]
  useEffect(() => {
    if (isLoadingEnd) {
      console.log(currentQues)
      setIsPlaying(true)
    }
  }, [currentQuesIndex])
  useEffect(() => {
    return () => {
      tickingElm.current.pause()
      console.log("in cleanup")
      setIsPlaying(false)
    }
  }, [])

  // console.log(allQuestions)
  // function handleAnswerClick(event, answerId) {
  //   if (isSubmitted) return;
  //   setIsSubmitted(true)

  //   let isRight = 0;
  //   let mobile = playerData.msisdn;
  //   let round = playerRound + 1;
  //   let questionId = currentQues.id;
  //   let selectedAns = `Option${answerId}`;
  //   let category = `general`;

  //   if (parseInt((currentQues.ans).slice(-1)) === answerId) {
  //     event.currentTarget.classList.add('bg_right')
  //     new Audio(rightAudio).play();
  //     setTotalRightAnswer((totalRightAnswer + 1))
  //     isRight = 1;
  //   } else {
  //     event.currentTarget.classList.add('bg_wrong')
  //     new Audio(wrongAudio).play()
  //     setTotalWrongAnswer((totalWrongAnswer + 1))
  //   }
  //   insertData(isRight, mobile, round, questionId, selectedAns, category, eventDetails.id);
  //   if (currentQuesIndex < (allQuestions.length - 1)) {
  //     setTimeout(() => {
  //       setIsPlaying(false)
  //       colorCleanUp('singleOptions')
  //       setCurrentQuesIndex((currentQuesIndex + 1))
  //       setIsSubmitted(false)
  //     }, 400);
  //   } else {
  //     gameDone()
  //   }
  // }

  function submitProgressRecord(questionIds) {
    let lastActiveTime = localStorage.getItem('quizPlay_lastActiveTime');
    let timeTaken = Math.floor(elapsedTime);
    if (lastActiveTime) {
      const wallClock = Math.floor((Date.now() - parseInt(lastActiveTime, 10)) / 1000);
      if (wallClock > 0) timeTaken = wallClock;
    }
    axios.post(`${baseUrl}/api/participant/quizplay_record`, {
      msisdn: playerData?.msisdn,
      category: null,
      time_taken: timeTaken,
      round_number: playerRound + 1,
      event: eventDetails.id,
      right_count: Number(sessionStorage.getItem('quizPlay_totalRightScore')) || 0,
      question_count: questionIds.length,
      serviceType: "Wordly",
      portal: 18,
      round_questions: questionIds
    }, {
      headers: { Authorization: `Token ${token}` }
    });
  }

  function recordAnswered(questionId) {
    answeredIds.current.push(questionId);
    if (answeredIds.current.length % 10 === 0) submitProgressRecord(answeredIds.current.slice());
  }

  function submitFinalScore(){
    // Calculate elapsed time in seconds between Date.now() and lastActiveTime from localStorage
    let lastActiveTime = localStorage.getItem('quizPlay_lastActiveTime');
    let totalTimeTakenLocalStorage = 0;
    if (lastActiveTime) {
      totalTimeTakenLocalStorage = Math.floor((Date.now() - parseInt(lastActiveTime, 10)) / 1000);
    }
    let finalTimeTaken = Math.min(Math.max(totalTimeTakenLocalStorage, Math.floor(elapsedTime)), 180)
    if(finalTimeTaken === 0 )return;
    axios.post(`${baseUrl}/api/participant/quizplay_summery_submission`, {
      msisdn: playerData?.msisdn,
      category: null,
      time_taken: finalTimeTaken,
      round_number: playerRound + 1,
      event: eventDetails.id,
      right_count: parseInt(sessionStorage.getItem('quizPlay_totalRightScore')),
      question_count: parseInt(sessionStorage.getItem('quizPlay_totalWrongScore')) + parseInt(sessionStorage.getItem('quizPlay_totalRightScore')),
      serviceType: "Wordly",
      portal: 18,
      round_questions: answeredIds.current.slice()
    }, {
      headers: { Authorization: `Token ${token}` }
    });
    localStorage.removeItem('quizPlay_lastActiveTime');
  }

  function gameDone() {
    submitFinalScore()
    sessionStorage.setItem('quizPlay_eventId', eventDetails.id);
    sessionStorage.setItem('quizPlay_passingScore', eventDetails.passing_score);
    setIsPlaying(false)
    setShowResultModal(true)
    navigate(`../?page=result&eventId=${eventDetails.id}`)
  }

  function singleTimerSubmit() {
    // console.log('singleSubmitted')
    insertData(0, playerData.msisdn, playerRound + 1, currentQues.id, 'notSelected', 'general', eventDetails.id)
    setIsSubmitted(false)
    setTotalWrongAnswer((totalWrongAnswer + 1))
    if (currentQuesIndex < (allQuestions.length - 1)) {
      setCurrentQuesIndex((currentQuesIndex + 1))
    } else {
      gameDone()
    }
  }

  function insertData(isRight, mobile, round, questionId, selectedAns, category, eventId) {
    // insert Data Function
    console.log(isRight, mobile, round, questionId, selectedAns, category, eventId)
    // axios.post(`${baseUrl}/api/participant/`, {
    //   is_right: isRight,
    //   msisdn: mobile,
    //   round_number: round,
    //   question: questionId,
    //   selected_answer: selectedAns,
    //   category: category,
    //   event: eventId,
    //   portal: portal
    // }, {
    //   headers: { Authorization: `Token ${token}` }
    // });
  }
  return (
    <>
      {allQuestions?.length && <MixUp props={{ insertData, playerData, playerRound, eventDetails, setFinalScore, setShowResultModal, gameDone,allQuestions,remainingTime,timerWidth,setShowPopUp,rightAudio,wrongAudio, recordSolved: recordAnswered, recordSkipped: recordAnswered }} />}
      {showPopUp && <PopUpMenu setShowPopUp={setShowPopUp} eventDetails={eventDetails} />}
      {/* insertData(0, playerData.msisdn, playerRound + 1, currentQues.id, 'notSelected', 'general', eventDetails.id) */}
    </>
  )
}

export default QuestionBodyBoishakh